import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { heroData, agentsData } from '../../data/mock';
import AnimatedGradient from '../ui/AnimatedGradient';

const HeroSection = () => {
  return (
    <section className="hero section-dark noise-overlay">
      {/* Animated Mesh Gradient Background */}
      <AnimatedGradient variant="mesh" />

      {/* Grid Pattern */}
      <div className="grid-pattern" />

      {/* Floating Particles */}
      <div className="particles">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${8 + Math.random() * 5}s`,
            }}
          />
        ))}
      </div>

      <div className="container" style={{ padding: '0 5%', width: '100%' }}>
        <div className="hero-grid">
          {/* Content */}
          <div className="hero-content">
            <h1>
              One prompt.<br />
              <span>A full AI team.</span>
            </h1>
            <p>{heroData.subheadline}</p>
            <div className="hero-buttons">
              <Link to="/coming-soon" className="btn-primary magnetic-btn glow-on-hover pulse-glow">
                {heroData.primaryCta}
                <ArrowRight size={18} />
              </Link>
              <button
                onClick={() => {
                  const element = document.getElementById('how-it-works');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="btn-secondary magnetic-btn"
              >
                {heroData.secondaryCta}
              </button>
            </div>
          </div>

          {/* Naabu Core Animation */}
          <div className="naabu-core-container">
            <div className="naabu-core">
              {/* Core Sphere */}
              <div className="core-sphere" />

              {/* Rings */}
              <div className="core-ring" />
              <div className="core-ring" />
              <div className="core-ring" />

              {/* Orbiting Agents */}
              <div className="orbit-container">
                {agentsData.slice(0, 8).map((agent, i) => (
                  <div
                    key={agent.id}
                    className="orbit-agent"
                    title={agent.name}
                    style={{
                      animationDelay: `${i * 0.3}s`,
                    }}
                  >
                    {agent.emoji}
                  </div>
                ))}
              </div>

              {/* Connection Lines */}
              <svg
                className="connection-lines"
                viewBox="0 0 400 400"
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '400px',
                  height: '400px',
                  opacity: 0.3,
                }}
              >
                {[...Array(8)].map((_, i) => {
                  const angle = (i / 8) * Math.PI * 2;
                  const x2 = 200 + Math.cos(angle) * 150;
                  const y2 = 200 + Math.sin(angle) * 150;
                  return (
                    <line
                      key={i}
                      x1="200"
                      y1="200"
                      x2={x2}
                      y2={y2}
                      stroke="#f06a15"
                      strokeWidth="1"
                      strokeDasharray="5,5"
                      style={{
                        animation: `lineGlow 2s ease-in-out ${i * 0.2}s infinite`,
                      }}
                    />
                  );
                })}
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Gradient Overlay at Bottom */}
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '200px',
          background: 'linear-gradient(to top, #000, transparent)',
          pointerEvents: 'none',
        }}
      />
    </section>
  );
};

export default HeroSection;
